import { AccountInfo } from "@azure/msal-browser";

import {
  acquireToken,
  getAccount,
  msalInstance,
} from "./msal";

import MSALUser from "../../domains/MSALUser";

import { getItemFromLocalStorage } from "../../config/localStorage";

export function reissueToken() {
  const accounts = msalInstance.getAllAccounts();

  const user = getItemFromLocalStorage<MSALUser>("AuthContext", null);
  const { homeAccountId } = user;

  const account = getAccount(accounts as AccountInfo[], {
    homeAccountId: homeAccountId,
  });

  return acquireToken(msalInstance, account as AccountInfo).then(response => {
    return {
      apiAccessToken: response?.apiAccessToken,
      apiAccessTokenExpiresOn: response?.apiAccessToken,
    };
  });
}
